import styled from 'styled-components';
import PlayButton from '../play-button/PlayButton';

export const PlayNow = styled(PlayButton)``;

export const EpisodeContainer = styled.div`
  display: grid;
  grid-template-columns: 5rem 1fr 5rem;
  grid-gap: 10px;
  align-items: center;
  padding: 1.5rem 2rem;
  margin: 0 -2rem;
  background: ${({ isLoadedNow }) => isLoadedNow && '#f7f7f7'};
  transition: all var(--transition);

  &:hover {
    background-color: #f7f7f7;
  }

  @media screen and (max-width: 800px) {
    margin: 0 -1.5rem;
    padding: 1.5rem 1.5rem;
    h3 {
      font-size: 1.6rem;
    }
  }

  @media (hover: hover) {
    ${PlayNow} {
      opacity: ${({ isLoadedNow }) => (isLoadedNow ? 1 : 0)};
    }
    &:hover {
      ${PlayNow} {
        opacity: 1;
      }
    }
  }
`;

export const EpisodeData = styled.span`
  color: #9e9e9e;
  font-weight: bold;
  margin-right: 2rem;
  @media screen and (max-width: 800px) {
    font-size: 1.4rem;
  }
`;

export const EpisodeDescription = styled.div`
  grid-column: 1/-1;
  padding: 3rem 4rem;
  background: #fff;
  border-radius: 10px;
  width: 100%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0px 20px 35px -20px rgba(0, 0, 0, 0.3);
  margin-top: 1rem;
  margin-bottom: 5rem;

  p {
    margin-bottom: 2rem;
  }
  a {
    color: #f9703e;
  }
  ul {
    margin-bottom: 2rem;
    li {
      margin-left: 4rem;
    }
  }
  @media screen and (max-width: 800px) {
    padding: 3rem 2rem;
  }
`;

export const DescriptionBtn = styled.span`
  cursor: pointer;
  font-size: 1.6rem;
  font-weight: bold;
  color: #f9703e;
  &:hover {
    text-decoration: underline;
  }
  @media screen and (max-width: 800px) {
    font-size: 1.4rem;
  }
`;
